"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const TabContext = react_1.createContext({});
TabContext.displayName = 'TabContext';
exports.default = TabContext;
